import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");

  const poll = useCallback(async (attempt) => {
    if (attempt > 8) { setStatus("timeout"); return; }
    try {
      const u = await refresh();
      if (u?.is_subscribed) { setStatus("paid"); return; }
    } catch {}
    setTimeout(() => poll(attempt + 1), 2000);
  }, [refresh]);

  useEffect(() => { poll(0); }, [poll]);

  return (
    <div className="max-w-md mx-auto text-center py-16">
      {status === "checking" && (
        <><Loader2 className="w-12 h-12 text-indigo-500 mx-auto animate-spin" /><p className="mt-4 text-slate-600 font-semibold">Ödemen kontrol ediliyor...</p></>
      )}
      {status === "paid" && (
        <div className="animate-pop-in" data-testid="payment-success">
          <div className="text-6xl mb-3">🎉</div>
          <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-slate-900 mt-3">Premium'a hoş geldin!</h1>
          <p className="text-slate-500 mt-2">Artık tüm konu anlatımları, soru-cevap ve deneme sınavları açık.</p>
          <Button data-testid="go-dashboard-btn" onClick={() => navigate("/panel")} className="mt-6 bg-indigo-600 hover:bg-indigo-700 rounded-xl font-bold px-8 py-6">
            Panele Git 🚀
          </Button>
        </div>
      )}
      {status === "timeout" && (
        <><p className="text-slate-600">Ödemen henüz görünmüyor. Onaylandıktan sonra birkaç dakika sürebilir.</p>
          <Button onClick={() => navigate("/abonelik")} className="mt-4 rounded-xl">Abonelik Sayfasına Dön</Button></>
      )}
    </div>
  );
}
